import { render, staticRenderFns } from "./SubmissionDraftEdit.vue?vue&type=template&id=26272923"
import script from "./SubmissionDraftEdit.vue?vue&type=script&lang=js"
export * from "./SubmissionDraftEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports